import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class DataRetentionPolicyGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		
		var policyGrid = this;
		setTimeout(function(){
			policyGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var policyGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filtercompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',				
					postinit: function(combo) {
						Service.getCompanyService().getCompaniesLookup().then(function(data){
							combo.items = data;
						});
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							actionRefresh();
						}
					}					
				},					
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['ADMIN_DATA_RETENTION_POLICY:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_DATA_RETENTION_POLICY:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',						
							theme: 'error primary',
							itemid: 'delete',
							disabled: true,
							'class': 'spacer-toolbar-item',
							style: 'float: right;margin-top: 18px;',
							permissions: ['ADMIN_DATA_RETENTION_POLICY:DELETE'],
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems[0]);
								}
							}
						}
					]
				}		
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [					
				{						
					path: 'companyName',
					header: 'Company Name',					
					width: '7em'
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},								
				{						
					path: 'updateUser',
					header: 'Update User',
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;
					} else {						
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;						
					}	
				}
			}
		});	
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function(companyId) {
						policyGrid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'companyName',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'DESC',
							companyId: companyId
						};

						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;						
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();						
						};

						DataManagementService.getDataRetentionService().getDataRetentionPolicies(policyGrid.currentFilter)
								.then(function(records){							
							successHandler(records);
						});	
					};					
										
					loadData(ElementUtil.query(toolbar, 'filtercompany').value);
														
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'data-retention-policies',
			onDetail: function() {
				ExportUtil.exportGridItemsAsCsv(grid.items, 'data-retention-policies.csv');
			}
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		policyGrid.append(flexLayout);		
				
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};
		
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit' : 'Add',
				icon: 'vaadin:edit',				
				width: .75,
				height: 450,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-combo-box',																																										
											name: 'companyId',
											label: 'Company (blank for global)',
											'item-value-path': 'code',
											'item-label-path': 'description',
											postinit: function (combo) {
												Service.getCompanyService().getCompaniesLookup().then(function (data) {
													combo.items = data;
												});
											},
											placeHolder: 'Select'					
										},
										{
											tag: 'vaadin-number-field',										
											name: 'errorTaskRetentionDays',
											label: 'Error Task Retention (Days)',
											required: true,
											min: 1,
											max: 365											
										},	
										{
											tag: 'vaadin-number-field',										
											name: 'completeTaskRetentionDays',
											label: 'Complete Task Retention (Days)',
											required: true,
											min: 1,
											max: 365											
										},
										{
											tag: 'vaadin-number-field',										
											name: 'generalReportHistoryRetentionDays',											
											label: 'Report History Retention (Days)',
											required: true,
											min: 1,
											max: 2190											
										},
										{
											tag: 'vaadin-number-field',										
											name: 'undoRetentionDays',
											label: 'Undo Retention (Days)',
											required: true,
											min: 1,
											max: 1825											
										},
										{
											tag: 'vaadin-number-field',										
											name: 'importHistoryNoDataRetentionDays',
											label: 'Import History No Data Retention (Days)',
											required: true,
											min: 1,
											max: 1825											
										},
										{
											tag: 'vaadin-number-field',										
											name: 'importHistoryUnitRetentionMonths',
											label: 'Import History Unit Retention (Months)',
											required: true,
											min: 1,
											max: 4											
										},
										{
											tag: 'vaadin-number-field',										
											name: 'autoRetireTractorsMonths',
											label: 'Auto Retire Tractors (Months)',
											required: true,
											min: 1,
											max: 60
										},
										{
											tag: 'vaadin-number-field',										
											name: 'archiveExpirationMonths',
											label: 'Archive Expiration Months (Months)',
											required: true,
											min: 1,
											max: 120
										},										
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																												
															formPanel.submitForm({
																preSubmit: function(data) {																	
																	return data;
																},
																actualCall: function(data) {			
																	if (record) {
																		data.policyId = record.policyId;
																	}
																	return DataManagementService.getDataRetentionService().saveDataRetentionPolicy(data, (record ? true : false));
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Data Retention Policy', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});															
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						if (record) {	
							formPanel.load(record);
														
						}
					}
				}
			});			
		};
		
		var actionDelete = function(record) {
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: '<b>Are you sure you want to delete policy"?</b>',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							DataManagementService.getDataRetentionService().deleteDataRetentionPolicy(record.policyId)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed Policy', {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
			
		};		
		

	}
	
}
customElements.define('dl-data-retention-policy-grid', DataRetentionPolicyGrid);
